import { createReducer, on } from '@ngrx/store';
import * as OrderTypesActions from './order-types.actions';
import { OrderType } from 'src/app/pages/dispatch/models/order.model';

export interface OrderTypesState {
  response: OrderType[] | null;
  error: any | null;
  loading: boolean;
  cache?: { [key: string]: OrderType[] };
}

export const initialState: OrderTypesState = {
  response: null,
  error: null,
  loading: false,
  cache: {},
};

export const orderTypesReducer = createReducer(
  initialState,
  on(OrderTypesActions.loadOrderTypes, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(OrderTypesActions.loadOrderTypesSuccess, (state, { response }) => ({
    ...state,
    loading: false,
    response,
    error: null,
  })),
  on(OrderTypesActions.loadOrderTypesFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
  on(OrderTypesActions.loadOrderTypesSuccessByKey, (state, { key, response }) => ({
    ...state,
    loading: false,
    response,
    cache: { ...(state.cache || {}), [key]: response },
    error: null,
  })),
);
